// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    settings: null,
  },
  reducers: {
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
  },
});
export const { setSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
